import Vue from 'vue'
import "babel-polyfill"
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate";
import api from "../api/index";
import request from "../api/request";

Vue.use(Vuex)
const store = new Vuex.Store({
    state: {
        searchText:{  // 加签
            chsList:[],  // 添加人员
            chsListInfo:{},  // 确定人员
            pageList:[],  //  表格数据
            totalPage: 0,  // 总页数
            pageSize: 10,  // 每页显示个数
            currentPage:1,  // 当前页数
            currentPageOther:1,// 外部人员当前页数
            inputVal:'',  // 搜索内容
            orgId:'',  // 组织机构id
            flag:null,  // 展示搜索类型'1,2'
            flagTree:3, // 树导航flag
            bizCode:'',  // 维度类型
            namePath:null,
        },
        userInfo: {},
        isNavMenuOpen: false,
    },
    getters: {

    },
    mutations: {
        setUserInfo(state, payload) {
            state.userInfo = payload;
        },
        setIsNavMenuOpen(state, payload) {
          state.isNavMenuOpen = payload;
        },
        setInputVal(state, payload) {
          state.searchText.inputVal = payload;
        },
    },
  actions: {
    getUserInfo({commit}) {
      return new Promise((resolve, reject) => {
        request(api.getUserInfo, {}, 'GET').then((response) => {
          commit('setUserInfo', response.data.data)
          resolve(response.data.data)
        }).catch(error => {
          reject(new Error('未授权，请登录'))
        })
      })
    },
    getWorkFlowPermission(){
      return new Promise((resolve, reject)=>{
        request(api.getWorkFlowDetailPermission, {}, 'GET').then((res)=>{
          const keys = Object.keys(res.data.data);
          resolve(keys.length > 0);
        })
      })
    },
    getUserMenu({commit}) {
      return new Promise((resolve, reject)=>{
        request(api.getUserInfo, {}, 'GET').then((response) => {
          console.log("1-api.getUserInfo",response)
          let data = response.data.data;
          window.MAIAAPM && window.MAIAAPM.setUid(response.data.data.username);
          zhuge.identify(data.username);
          zhuge.track('admin-人员信息',{
            person:data.username,
          });

          const userId = response.data.data.userId || '000008ec-5431-4420-b0c5-000011110000';
          const api_getUserMenu = `${api.getUserInfo}/${userId}/tabs`;
          request(api_getUserMenu, {}, 'GET').then((res2) => {
            console.log("2-api_getUserMenu",res2);

            request(api.getWorkFlowDetailPermission, {}, 'GET').then((res1)=>{
              console.log("3-api.getWorkFlowDetailPermission",res1)
              const keys = Object.keys(res1.data.data);
              resolve(keys.length > 0);
              let data = {
                ... response.data.data,
                routeList: res2.data.data[0].functions,
                permission: keys.length > 0,
              };
              commit('setUserInfo', data);
              resolve();
            })
          })
        }).catch(error => {
          console.log(error);
          reject(new Error('未授权，请登录'));
        })
      })
    },
    },
    // 解决f5刷新数据不丢失的问题
    plugins: [
        createPersistedState({
            storage: window.sessionStorage,
            reducer(val) {
                return {
                    userInfo: val.userInfo,
                };
            }
        })
    ]
})

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js